/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeferredIncomeHistoryDtoFundingRequest
 */
export interface DeferredIncomeHistoryDtoFundingRequest {
  /**
   *
   * @type {string}
   * @memberof DeferredIncomeHistoryDtoFundingRequest
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof DeferredIncomeHistoryDtoFundingRequest
   */
  number: number;
  /**
   *
   * @type {Date}
   * @memberof DeferredIncomeHistoryDtoFundingRequest
   */
  createdAt: Date;
  /**
   *
   * @type {string}
   * @memberof DeferredIncomeHistoryDtoFundingRequest
   */
  name: string;
}

export function DeferredIncomeHistoryDtoFundingRequestFromJSON(json: any): DeferredIncomeHistoryDtoFundingRequest {
  return DeferredIncomeHistoryDtoFundingRequestFromJSONTyped(json, false);
}

export function DeferredIncomeHistoryDtoFundingRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DeferredIncomeHistoryDtoFundingRequest {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    number: json["number"],
    createdAt: new Date(json["createdAt"]),
    name: json["name"],
  };
}

export function DeferredIncomeHistoryDtoFundingRequestToJSON(
  value?: DeferredIncomeHistoryDtoFundingRequest | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    number: value.number,
    createdAt: value.createdAt.toISOString(),
    name: value.name,
  };
}
